import {RefObject, useEffect, useRef} from "react";

import {IReelsBasePayload, reelsAnalytics} from "../tracking/reels_gtm_events";

interface IProps {
    reelListIndex: number;
    videoRef?: RefObject<HTMLVideoElement>;
    isReady: boolean;
    gtmPayload: IReelsBasePayload;
}

export const useReelPlayerProgressAnalytics = (props: IProps) => {
    const reportStatus = useRef({
        0: false,
        90: false
    });

    const reportProgress = (progressPercentage: number) => {
        const normalizedProgressPercentage = normalizeProgressPercentage(progressPercentage);

        if (!reportStatus.current[normalizedProgressPercentage]) {
            reportStatus.current[normalizedProgressPercentage] = true;
            // Report progress to analytics
            reelsAnalytics.gtm.reelViewEvent(props.gtmPayload, normalizedProgressPercentage);
        }
    };

    useEffect(() => {
        if (!props.videoRef?.current || !props.isReady) {
            return;
        }

        const onTimeUpdate = () => {
            const video = props.videoRef?.current;

            if (video) {
                const newProgress = (video.currentTime * 100) / video.duration;
                reportProgress(newProgress);
            }
        };

        props.videoRef.current.addEventListener("timeupdate", onTimeUpdate);

        return () => {
            props.videoRef?.current?.removeEventListener("timeupdate", onTimeUpdate);
        };
    }, [props.isReady]);
};

const normalizeProgressPercentage = (progressPercentage: number) => {
    if (progressPercentage > 85) {
        return 90;
    }

    return 0;
};
import {RefObject, useEffect, useRef} from "react";

import {IReelsBasePayload, reelsAnalytics} from "../tracking/reels_gtm_events";

interface IProps {
    reelListIndex: number;
    videoRef?: RefObject<HTMLVideoElement>;
    isReady: boolean;
    gtmPayload: IReelsBasePayload;
}

export const useReelPlayerProgressAnalytics = (props: IProps) => {
    const reportStatus = useRef({
        0: false,
        90: false
    });

    const reportProgress = (progressPercentage: number) => {
        const normalizedProgressPercentage = normalizeProgressPercentage(progressPercentage);

        if (!reportStatus.current[normalizedProgressPercentage]) {
            reportStatus.current[normalizedProgressPercentage] = true;
            // Report progress to analytics
            reelsAnalytics.gtm.reelViewEvent(props.gtmPayload, normalizedProgressPercentage);
        }
    };

    useEffect(() => {
        if (!props.videoRef?.current || !props.isReady) {
            return;
        }

        const onTimeUpdate = () => {
            const video = props.videoRef?.current;

            if (video) {
                const newProgress = (video.currentTime * 100) / video.duration;
                reportProgress(newProgress);
            }
        };

        props.videoRef.current.addEventListener("timeupdate", onTimeUpdate);

        return () => {
            props.videoRef?.current?.removeEventListener("timeupdate", onTimeUpdate);
        };
    }, [props.isReady]);
};

const normalizeProgressPercentage = (progressPercentage: number) => {
    if (progressPercentage > 85) {
        return 90;
    }

    return 0;
};
